var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGridView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10.8V10.8H6V6Z",
    fill: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 6H18V10.8H13.2V6Z",
    fill: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.2H10.8V18H6V13.2Z",
    fill: "#9F9F9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 13.2H18V18H13.2V13.2Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGridView);
export default __webpack_public_path__ + "static/media/icon-grid-view.675524cadf4907d840453e585428d690.svg";
export { ForwardRef as ReactComponent };